import { Modal } from "@commonlibs";
import styled, { css } from "styled-components";

export const CardModalRoot = styled(Modal)(
    ({ theme }) => css`
        height: unset;
        border-radius: unset;
        box-shadow: unset;
        position: absolute;
        bottom: 0;
        width: 100%;
        max-width: unset;
        max-height: 87%;
        border-top-left-radius: ${theme.borderRadius};
        border-top-right-radius: ${theme.borderRadius};
        padding: 0;
        &.fullScreen {
            border-radius: unset;
            max-height: unset;
            height: 100%;
        }
    `,
);
